<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Employee</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Employee</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_employee"
                  ><i class="fa fa-plus"></i> Add Employee</a
                >
                <div class="view-icons">
                  <router-link to="/employees" class="grid-view btn btn-link"
                    ><i class="fa fa-th"></i>
                  </router-link>
                  <router-link to="/employeeslist" class="grid-view btn btn-link active"
                    ><i class="fa fa-bars"></i
                  ></router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input type="text" class="form-control floating" />
                <label class="focus-label">Employee ID</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input type="text" class="form-control floating" />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <select class="select floating">
                  <option>Select Designation</option>
                  <option>Web Developer</option>
                  <option>Web Designer</option>
                  <option>Android Developer</option>
                  <option>Ios Developer</option>
                </select>
                <label class="focus-label">Designation</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a href="#" class="btn btn-success btn-block"> Search </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table datatable">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Employee ID</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th class="text-nowrap">Join Date</th>
                      <th>Role</th>
                      <th class="text-right no-sort">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >John Doe <span>Web Designer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0001</td>
                      <td>johndoe@example.com</td>
                      <td>9876543210</td>
                      <td>1 Jan 2013</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-09.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >Richard Miles <span>Web Developer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0002</td>
                      <td>richardmiles@example.com</td>
                      <td>9876543210</td>
                      <td>18 Mar 2014</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-10.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >John Smith <span>Android Developer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0003</td>
                      <td>johnsmith@example.com</td>
                      <td>9876543210</td>
                      <td>1 Apr 2014</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-05.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >Mike Litorus <span>IOS Developer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0004</td>
                      <td>mikelitorus@example.com</td>
                      <td>9876543210</td>
                      <td>1 Apr 2014</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-11.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >Wilmer Deluna <span>Team Leader</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0005</td>
                      <td>wilmerdeluna@example.com</td>
                      <td>9876543210</td>
                      <td>22 May 2014</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-12.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >Jeffrey Warden <span>Web Developer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0006</td>
                      <td>jeffreywarden@example.com</td>
                      <td>9876543210</td>
                      <td>16 Jun 2013</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2 class="table-avatar">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="~@/assets/profiles/avatar-13.jpg"
                          /></router-link>
                          <router-link to="/profile"
                            >Bernardo Galaviz <span>Web Developer</span>
                          </router-link>
                        </h2>
                      </td>
                      <td>FT-0007</td>
                      <td>bernardogalaviz@example.com</td>
                      <td>9876543210</td>
                      <td>1 Jan 2013</td>
                      <td>
                        <div class="dropdown">
                          <a
                            href=""
                            class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            >Web Developer
                          </a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Software Engineer</a>
                            <a class="dropdown-item" href="#">Software Tester</a>
                            <a class="dropdown-item" href="#">Frontend Developer</a>
                            <a class="dropdown-item" href="#">UI/UX Developer</a>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#edit_employee"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              data-toggle="modal"
                              data-target="#delete_employee"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Employee Modal -->
        <div id="add_employee" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Employee</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input class="form-control" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Last Name</label>
                        <input class="form-control" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Username <span class="text-danger">*</span></label
                        >
                        <input class="form-control" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Email <span class="text-danger">*</span></label
                        >
                        <input class="form-control" type="email" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Password</label>
                        <input class="form-control" type="password" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Confirm Password</label>
                        <input class="form-control" type="password" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Employee ID <span class="text-danger">*</span></label
                        >
                        <input type="text" class="form-control" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Joining Date <span class="text-danger">*</span></label
                        >
                        <div class="cal-icon">
                          <input class="form-control datetimepicker" type="text" />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Phone </label>
                        <input class="form-control" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Company</label>
                        <select class="select">
                          <option value="">Global Technologies</option>
                          <option value="1">Delta Infotech</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Department <span class="text-danger">*</span></label>
                        <select class="select">
                          <option>Select Department</option>
                          <option>Web Development</option>
                          <option>IT Management</option>
                          <option>Marketing</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Designation <span class="text-danger">*</span></label>
                        <select class="select">
                          <option>Select Designation</option>
                          <option>Web Designer</option>
                          <option>Web Developer</option>
                          <option>Android Developer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive m-t-15">
                    <table class="table table-striped custom-table">
                      <thead>
                        <tr>
                          <th>Module Permission</th>
                          <th class="text-center">Read</th>
                          <th class="text-center">Write</th>
                          <th class="text-center">Create</th>
                          <th class="text-center">Delete</th>
                          <th class="text-center">Import</th>
                          <th class="text-center">Export</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Holidays</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Leaves</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Clients</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Projects</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Tasks</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Chats</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Assets</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Timing Sheets</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Employee Modal -->

        <!-- Edit Employee Modal -->
        <div id="edit_employee" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Employee</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input class="form-control" value="John" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Last Name</label>
                        <input class="form-control" value="Doe" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Username <span class="text-danger">*</span></label
                        >
                        <input class="form-control" value="johndoe" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Email <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          value="johndoe@example.com"
                          type="email"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Password</label>
                        <input class="form-control" value="johndoe" type="password" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Confirm Password</label>
                        <input class="form-control" value="johndoe" type="password" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Employee ID <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          value="FT-0001"
                          readonly
                          class="form-control floating"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Joining Date <span class="text-danger">*</span></label
                        >
                        <div class="cal-icon">
                          <input class="form-control datetimepicker" type="text" />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Phone </label>
                        <input class="form-control" value="9876543210" type="text" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label">Company</label>
                        <select class="select">
                          <option>Global Technologies</option>
                          <option>Delta Infotech</option>
                          <option selected>International Software Inc</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Department <span class="text-danger">*</span></label>
                        <select class="select">
                          <option>Select Department</option>
                          <option>Web Development</option>
                          <option>IT Management</option>
                          <option>Marketing</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Designation <span class="text-danger">*</span></label>
                        <select class="select">
                          <option>Select Designation</option>
                          <option>Web Designer</option>
                          <option>Web Developer</option>
                          <option>Android Developer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive m-t-15">
                    <table class="table table-striped custom-table">
                      <thead>
                        <tr>
                          <th>Module Permission</th>
                          <th class="text-center">Read</th>
                          <th class="text-center">Write</th>
                          <th class="text-center">Create</th>
                          <th class="text-center">Delete</th>
                          <th class="text-center">Import</th>
                          <th class="text-center">Export</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Holidays</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Leaves</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Clients</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Projects</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Tasks</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Chats</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Assets</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                        <tr>
                          <td>Timing Sheets</td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input checked="" type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Employee Modal -->

        <!-- Delete Employee Modal -->
        <div class="modal custom-modal fade" id="delete_employee" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Employee</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a href="javascript:void(0);" class="btn btn-primary continue-btn"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false,
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass("focused", e.type === "focus" || this.value.length > 0);
        })
        .trigger("blur");
    }
  },
  name: "employeeslist",
};
</script>



// WEBPACK FOOTER //
// src/components/employees/employeeslist.vue